import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ErrorCodes, FileModel, ModalService } from '@shared';
import { IImportHandler } from '../import-process/import-handler.interface';
import { LoggingService } from '@shared/logging';
import { EditWorkFileNameModalComponent } from '@pages/smart-components';

@Injectable({
	providedIn: 'root'
})
export class EditWorkFileNameHandler implements IImportHandler {
	public inputChanged$: Observable<string>;

	private inputChangeSubject: Subject<string> = new Subject();
	private next: IImportHandler;

	public constructor(
		private modalService: ModalService,
		private loggingService: LoggingService
	) {
		this.inputChanged$ = this.inputChangeSubject.asObservable();
	}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		await this.openModal(model);

		if (this.next) {
			await this.next.handle(model);
		}
	}

	private async openModal(model: FileModel) {
		try {
			await this.modalService.createAndShow(
				EditWorkFileNameModalComponent,
				'edit-workfileName-modal',
				{
					workfileName: model.FileDisplayName
				},
				false
			);

			const response = await this.modalService.onDidDismiss();

			if (response.data !== undefined) {
				model.FileDisplayName = response.data.workfileName;
			}
		} catch (error) {
			this.loggingService.error(ErrorCodes.EditWorkFileNameHandler, error);
			throw new Error('Edit workfilename failed');
		}
	}
}
